import type { FC } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { PropertyDetailPageLegacy } from "web_myplann/Portfolio/Pages/PropertyDetailPageLegacy";
import { PropertyDetailPageRedesign } from "web_myplann/Portfolio/Pages/PropertyDetailPageRedesign";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

export const PropertyDetailPage: FC = () => {
	const { hasRight: hasPortfolioRight, isPending } =
		usePortfolioRightOptional();

	if (isPending) {
		return <MyPlannLoading />;
	}

	return hasPortfolioRight ? (
		<PropertyDetailPageRedesign />
	) : (
		<PropertyDetailPageLegacy />
	);
};
